'use client';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import type { BoxProps } from '@mui/material';
import type { Property } from 'csstype';
import type { FC, ReactNode } from 'react';

export interface ImageHoverInnerZoomProps extends ImageHoverInnerZoomStyledProps, BoxProps {
  children: ReactNode;
}

/**
 * Wraps around an Image Element. Zooms into the Image on Hover
 * @param children - Image Element. Can be nested
 * @param props - BoxProps
 */

export const ImageHoverInnerZoom: FC<ImageHoverInnerZoomProps> = ({
  children,
  ...props
}) => (
  <RootStyle {...props}>
    {children}
  </RootStyle>
);

interface ImageHoverInnerZoomStyledProps {
  zoomFactor?: number;
  transitionDuration?:
    | string[]
    | Property.TransitionDuration<string>
    | Array<Property.TransitionDuration<string>>
    | undefined;
  transitionTimingFunction?:
    | string[]
    | Property.TransitionTimingFunction
    | Property.TransitionTimingFunction[]
    | undefined;
  transitionDelay?:
    | string[]
    | Property.TransitionDelay<string>
    | Array<Property.TransitionDelay<string>>
    | undefined;
}

const RootStyle = styled( Box, {
  shouldForwardProp: (prop) =>
    prop !== 'zoomFactor'
    && prop !== 'transitionDelay'
    && prop !== 'transitionTimingFunction'
    && prop !== 'transitionDelay',
} )<ImageHoverInnerZoomStyledProps>(
  ({
    zoomFactor = 1.1,
    transitionDelay = '0s',
    transitionDuration = '0.5s',
    transitionTimingFunction = 'ease',
  }) => ({
    overflow: 'hidden',
    '& img': {
      willChange: 'transform',
      transitionProperty: 'transform !important',
      transitionDuration: `${transitionDuration} !important`,
      transitionTimingFunction: `${transitionTimingFunction} !important`,
      transitionDelay: `${transitionDelay}!important`,
      imageRendering: '-webkit-optimize-contrast',
      '-ms-interpolation-mode': 'nearest-neighbor',
    },
    '&:hover img': {
      willChange: 'scale',
      transform: `scale(${zoomFactor})`,
      '-ms-transform': `scale(${zoomFactor})`, /* IE 9 */
      '-webkit-transform': `scale(${zoomFactor})`,
    },
  })
);
